import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

/**
 * Formats a given date (string or Date object) into "MMM dd" format.
 *
 * @example output
 * "Mar 19"
 */
export const getFormattedDateInMMMDD = (dateInput: string | Date): string => {
  const date = typeof dateInput === 'string' ? parseISO(dateInput) : dateInput;

  return format(date, 'MMM dd');
};
